import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarServices" */ './lazyIndex')
);

export const lazyGetCalendarViewRESTService = new LazyAction(
    lazyModule,
    m => m.getCalendarViewRESTService
);

export const lazyGetInitialPageEndpoint = new LazyAction(lazyModule, m => m.getInitialPageEndpoint);
export const lazyGetEventByUIdRestService = new LazyAction(
    lazyModule,
    m => m.getEventByUIdRestService
);

export const lazyCreateCalendarUsingRestService = new LazyAction(
    lazyModule,
    m => m.createCalendarUsingRestService
);
export type { default as CreateCalendarUsingRestServiceRequest } from './schema/CreateCalendarUsingRestServiceRequest';
